<p-dialog
  [(visible)]="displayModal"
  [draggable]="false"
  responsive="true"
  appendTo="body"
  [closeOnEscape]="!modal?.disableEsc"
  [dismissableMask]="modal?.dismissableMask"
  [modal]="true"
>
  <!-- p-dialog header section starts from here -->
  <p-header>
    <span #mod tabindex="0"></span>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo" id="pdialog-logo"></i>
      <a
        id="pdialog-anchor"
        tabindex="0"
        [attr.aria-label]="modal?.closableText"
        class="close-x"
        (click)="displayModal = false"
      >
        <i id="pdialog-crosslogo" [ngClass]="{ 'fa fa-times': !modal?.disableDismiss }"></i>
      </a>
    </div>
    <h3 id="pdialog-headertext">{{ modal?.headerText }}</h3>
  </p-header>
  <!-- p-dialog header section ends here -->
  <div class="row" *ngIf="errorMessage">
    <div class="col-12 m-t-lg">
      <tmo-error-message-detail
        [errorMessage]="errorMessage"
        pdlPageComponentId="ErrorDetailComponent"
      ></tmo-error-message-detail>
    </div>
  </div>
  <p class="small" id="pdialog-bodytext" [innerHtml]="modal?.bodyText"></p>

  <!-- p-dialog footer section starts from here -->
  <p-footer>
    <div
      class="button-spacing text-center d-block"
      [class.buttons-container-vertical]="true"
      [class.buttons-container]="true"
    >
      <div *ngFor="let button of modal?.buttons; let ind = index" class="button-box m-r-xl">
        <tmo-button
          [button]="button"
          id="pdialog-button-{{ ind }}"
          [aria-label]="button?.name"
          (onSelect)="handleClickEvent($event)"
          [disabled]="button?.disabled ? button?.disabled : false"
          >{{ button?.name }}</tmo-button
        >
      </div>
    </div>
  </p-footer>
  <tmo-spinner [setDelay]="!showLoader"></tmo-spinner>
  <!-- p-dialog footer section ends here -->
</p-dialog>
